(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-product-list-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const tab = event.target.closest('.pi-product-list-tabs__tab');
    if (!tab) return;
    const root = tab.closest('[data-pi-product-list-tabs]');
    if (!root) return;
    const target = tab.getAttribute('data-target');
    if (!target) return;

    root.querySelectorAll('.pi-product-list-tabs__tab').forEach(function (el) {
      const on = el === tab;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    root.querySelectorAll('.pi-product-list-tabs__panel').forEach(function (panel) {
      const on = panel.getAttribute('data-panel') === target;
      if (on) {
        panel.removeAttribute('hidden');
        panel.classList.add('is-active');
      } else {
        panel.setAttribute('hidden', '');
        panel.classList.remove('is-active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
